import { useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import Header from "../../../Dashboard/Header";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  TextField,
  Button,
  Box,
  Typography,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import Swal from "sweetalert2";
import ShowVoucherDetails from "./ShowVoucherDetails";
const PREFERENCE_KEY = "infiniteAppUserPreferences";
const SELECTED_VCH_TYPE_KEY = "secondaryApprovalSelectedVchType";

// Add CSS for SweetAlert container positioning
const style = document.createElement('style');
style.textContent = `
  .swal-container-show-voucher-details {
    position: fixed;
    z-index: 10000;
  }
  
  .swal-container-secondary-approval-table {
    position: fixed;
    z-index: 10000;
  }
`;
document.head.appendChild(style);

const SecVchApprov = () => {
  //states and local Variable
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const [SecVchs, setVouchers] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [rejectId, setrejectId] = useState("");
  const [rejectReason, setrejectReason] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [openPeriod, setOpenPeriod] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [bulkReject, setBulkReject] = useState(false);
  const [VchTypes, setVchTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Ref for the text field
  const remarkTextFieldRef = useRef(null);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  // Load saved voucher type from localStorage
  const savedVchType = localStorage.getItem(SELECTED_VCH_TYPE_KEY);
  const [vchTypeName, setvchTypeName] = useState(savedVchType || "");

  const handleVchTypeChange = (event) => {
    const value = event.target.value;
    setvchTypeName(value);
    // Save to localStorage
    localStorage.setItem(SELECTED_VCH_TYPE_KEY, value);
    fetchData(value);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ===============================

  const [vchdata, setvchdata] = useState([]);

  const ConfigVchDet = async (SecVch) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/voucherType`,
        { cmpid },
        { headers: { Authorization: token } }
      );
      const voucherstypes = response.data.vchTypeMap[0].vchType;

      const selectedConfigs = voucherstypes
        .map((vch) => {
          const match = SecVch.find((sec) => sec.vch_type === vch.vchTypeName);
          return match ? vch : null;
        })
        .filter(Boolean);

      setvchdata(selectedConfigs[0]);
    } catch (err) {
      console.log(err);
    }
  };

  // Function to show SweetAlert above specific container
  const showSweetAlert = (config, containerId = null) => {
    const swalConfig = {
      ...config,
      customClass: {
        popup: "small-alert",
        container: containerId ? `swal-container-${containerId}` : "",
      },
    };

    return Swal.fire(swalConfig);
  };

  //function to fecth Secondary Approval Vouchers
  const fetchData = async (selectedType = vchTypeName) => {
    setIsLoading(true);
    const Secvchbody = {
      cmpid: cmpid,
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/vchSecondaryList",
        Secvchbody,
        {
          headers: { Authorization: token },
        }
      );
      const SecVcharrayData = Object.values(response.data);
      
      // Sort voucher data by voucher number in ascending order initially
      const sortedSecVcharrayData = SecVcharrayData.sort((a, b) => {
        // Convert voucher numbers to numbers for proper numerical sorting
        const vchNumA = parseInt(a.vch_number) || 0;
        const vchNumB = parseInt(b.vch_number) || 0;
        return vchNumA - vchNumB;
      });

      // Get unique Vch Type
      const uniqueVchtype = sortedSecVcharrayData.filter(
        (item, index, self) =>
          index === self.findIndex((obj) => obj.vch_type === item.vch_type)
      );
      setVchTypes(uniqueVchtype);

      if (!selectedType) {
        setVouchers(sortedSecVcharrayData);
      } else {
        const vchtypeFlt = sortedSecVcharrayData.filter(
          (row) => row.vch_type === selectedType
        );
        setVouchers(vchtypeFlt);
        
        // If selected type has no data, check other available types
        if (vchtypeFlt.length === 0 && uniqueVchtype.length > 0) {
          // Find the first available voucher type
          const availableType = uniqueVchtype.find(type => {
            const filteredData = sortedSecVcharrayData.filter(row => row.vch_type === type.vch_type);
            return filteredData.length > 0;
          });
          
          if (availableType) {
            // Auto-switch to available voucher type
            const newVchType = availableType.vch_type;
            const newFilteredData = sortedSecVcharrayData.filter(
              (row) => row.vch_type === newVchType
            );
            setVouchers(newFilteredData);
            setvchTypeName(newVchType);
            localStorage.setItem(SELECTED_VCH_TYPE_KEY, newVchType);
          }
        }
      }
      ConfigVchDet(sortedSecVcharrayData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  // ===========================================================
  
  // Function to handle approval from ShowVoucherDetails
  const handleVoucherApprove = async (vchId) => {
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + `/approvalModule/vchSecondaryUpdate`,
        {
          vchid: vchId,
          status: 1,
          rejectionremark: "",
          vchlevel: vchdata.approvalConfig[0].level,
        },
        {
          headers: { Authorization: token },
        }
      );
      
      // Success Alert - Show above ShowVoucherDetails
      showSweetAlert({
        title: "Approved!",
        text: "Voucher Entry Approved successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }, "show-voucher-details").then((result) => {
        if (result.isConfirmed) {
          // Close the voucher details dialog
          setViewOpen(false);
          // Refresh data
          fetchData();
        }
      });
    } catch (error) {
      // Error alert - Show above ShowVoucherDetails
      showSweetAlert({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
      }, "show-voucher-details");
    }
  };

  // Function to handle rejection from ShowVoucherDetails
  const handleVoucherReject = async (vchId, rejectReason) => {
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + `/approvalModule/vchSecondaryUpdate`,
        {
          vchid: vchId,
          status: 0,
          rejectionremark: rejectReason,
          vchlevel: vchdata.approvalConfig[0].level,
        },
        {
          headers: { Authorization: token },
        }
      );
      
      // Success Alert for rejection - Show above ShowVoucherDetails
      showSweetAlert({
        title: "Rejected!",
        text: "Voucher Entry has been rejected.",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }, "show-voucher-details").then((result) => {
        if (result.isConfirmed) {
          // Close the voucher details dialog
          setViewOpen(false);
          // Refresh data
          fetchData();
        }
      });
    } catch (error) {
      // Error alert - Show above ShowVoucherDetails
      showSweetAlert({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
      }, "show-voucher-details");
    }
  };

  const hnadleReject = (id) => {
    setrejectId(id);
    setBulkReject(false);
    setOpen(true);
  };

  //call on approve button to handle approval and reject in table
  const handleApproval = async (id, status) => {
    const rejectionremark = rejectReason;
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + `/approvalModule/vchSecondaryUpdate`,
        {
          vchid: id,
          status,
          rejectionremark,
          vchlevel: vchdata.approvalConfig[0].level,
        },
        {
          headers: { Authorization: token },
        }
      );

      // Remove the voucher from local state immediately
      setVouchers(prev => prev.filter((SecVch) => SecVch.vch_id !== id));
      
      if (status == 1) {
        // Success Alert - Show above secondary-approval table
        showSweetAlert({
          title: "Approved!",
          text: "Voucher Entry Approved successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#28a745",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }, "secondary-approval-table").then((result) => {
          if (result.isConfirmed) {
            // Refresh data to check if we need to switch voucher types
            fetchData();
          }
        });
      } else if (status == 0) {
        // Success alert - Show above secondary-approval table
        showSweetAlert({
          title: "Rejected!",
          text: "Voucher Entry has been rejected.",
          icon: "error",
          confirmButtonText: "Close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }, "secondary-approval-table").then((result) => {
          if (result.isConfirmed) {
            // Refresh data to check if we need to switch voucher types
            fetchData();
          }
        });
        handleClose();
      }
      setrejectReason("");
    } catch (error) {
      console.log(error);
      //error alert - Show above secondary-approval table
      showSweetAlert({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
      }, "secondary-approval-table");
    }
  };

  //Handle to bulk aprroval and reject
  const handleApprovalAll = (status) => {
    const selectedVoucherIds = SecRows.filter((SecRows) =>
      selectedIds.includes(SecRows.id)
    ).map((SecRows) => SecRows.id);

    if (selectedVoucherIds.length === 0) {
      showSweetAlert({
        title: "Warning",
        text: "Please select check box for Multiple Approval/Rejection.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#f0ad4e",
        width: "300px",
        padding: "1em",
      }, "secondary-approval-table");
      return;
    }

    if (status === 0) {
      // For rejection, open the remark dialog
      setBulkReject(true);
      setOpen(true);
    } else {
      // For approval, proceed directly
      processBulkApproval(selectedVoucherIds, status);
    }
  };

  const processBulkApproval = async (
    selectedVoucherIds,
    status,
    rejectionRemark = ""
  ) => {
    const formattedArray = selectedVoucherIds.map((id) => ({
      vchid: id,
      status,
      rejectionremark: rejectionRemark,
      vchLevel: vchdata.approvalConfig[0].level,
    }));

    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/allVchSecondaryUpdate",
        formattedArray,
        {
          headers: { Authorization: token },
        }
      );

      // Remove approved/rejected vouchers from local state
      setVouchers(prev => prev.filter(vch => !selectedVoucherIds.includes(vch.vch_id)));

      if (status === 1) {
        // Success Alert for approval - Show above secondary-approval table
        showSweetAlert({
          title: "Approved!",
          text: "Approved successfully.",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "#28a745",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }, "secondary-approval-table").then((result) => {
          if (result.isConfirmed) {
            // Refresh data
            fetchData();
          }
        });
      } else {
        // Success Alert for rejection - Show above secondary-approval table
        showSweetAlert({
          title: "Rejected!",
          text: "Voucher Entries have been rejected.",
          icon: "error",
          confirmButtonText: "close",
          confirmButtonColor: "red",
          width: "300px",
          padding: "1em",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
        }, "secondary-approval-table").then((result) => {
          if (result.isConfirmed) {
            // Refresh data
            fetchData();
          }
        });
      }
    } catch (error) {
      // Error alert - Show above secondary-approval table
      showSweetAlert({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
      }, "secondary-approval-table");
    }
  };

  const convertDate = (dateString) => {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${day} /${month} /${year}`;
  };

  // Filter data  initial state
  const [filteredData, setFilteredData] = useState([]); // initial data

  const handleApply = () => {
    let result = SecVchs;
    // console.log("Original Data", result);

    if (fromDate || toDate) {
      //vchTypeName
      result = result.filter((row) => {
        // Convert row.vch_date (YYYYMMDD) into valid Date
        const dateStr = row.vch_date.toString();
        const rowDate = new Date(
          `${dateStr.substring(0, 4)}-${dateStr.substring(
            4,
            6
          )}-${dateStr.substring(6, 8)}`
        );

        const from = fromDate ? new Date(fromDate) : null;
        const to = toDate ? new Date(toDate) : null;

        if (from && to) return rowDate >= from && rowDate <= to;
        if (from) return rowDate >= from;
        if (to) return rowDate <= to;
        return true;
      });
    } else {
      result = SecVchs;
    }

    setFilteredData(result);
    setOpenPeriod(false);
  };

  const DateFilterData = !fromDate && !toDate ? SecVchs : filteredData;

  //rows for approval Voucher table
  const SecRows = Array.isArray(DateFilterData)
    ? DateFilterData.map((SecVch) => ({
        id: SecVch.vch_id,
        vchDate: convertDate(SecVch.vch_date),
        partyName: SecVch.PartyName,
        vchNumber: SecVch.vch_number,
        vchTypes: SecVch.vch_type,
        vchAmount: SecVch.vch_Amount,
        reject_Remark: SecVch.reject_Remark,
      }))
    : [];

  //colums width for Secondary vouchers table

  const getColumnWidth = (SecRows, field, header) => {
    const maxLength = Math.max(
      ...SecRows.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 15;
  };

  const SecColumns = [
    {
      field: "vchDate",
      headerName: "Date",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(SecRows, "vchDate", "Date"),
    },
    {
      field: "partyName",
      headerName: "Particulars",
      headerAlign: "left",
      align: "left",
      width: Math.min(getColumnWidth(SecRows, "partyName", "Particulars"), 200),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "vchNumber",
      headerName: "Vch No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(SecRows, "vchNumber", "Vch No") + 50,
      sortable: true,
    },
    {
      field: "vchAmount",
      headerName: "Amount",
      headerAlign: "right",
      align: "right",
      width: getColumnWidth(SecRows, "vchAmount", "Amount"),
      sortable: true,
    },
    {
      field: "vchTypes",
      headerName: "Vch Types",
      headerAlign: "left",
      align: "left",
      width: getColumnWidth(SecRows, "vchTypes", "Vch Types"),
    },
    {
      field: "reject_Remark",
      headerName: "Remark",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: Math.min(getColumnWidth(SecRows, "reject_Remark", "Remark"), 150),
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "action",
      headerName: "",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      headerClassName: "sticky-col-header",
      cellClassName: "sticky-col",
      width: 250,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="success"
            style={{ height: 20, fontSize: 15 }}
            startIcon={<VerifiedIcon />}
            onClick={(e) => {
              e.stopPropagation();
              handleApproval(params.id, "1");
            }}
          >
            {" "}
            Approve{" "}
          </Button>
  
          <Button
            variant="contained"
            color="error"
            style={{
              height: 20,
            }}
            startIcon={<CancelRoundedIcon />}
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              hnadleReject(params.id);
            }}
          >
            Reject
          </Button>
        </Box>
      ),
    },
  ];

  //add reject reason Popup Form
  //========================================================
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setrejectReason("");
    setBulkReject(false);
  };

  // Focus on text field when dialog opens
  useEffect(() => {
    if (open && remarkTextFieldRef.current) {
      // Small timeout to ensure the dialog is fully rendered
      const timer = setTimeout(() => {
        if (remarkTextFieldRef.current) {
          remarkTextFieldRef.current.focus();
          // Select all text for easy replacement
          remarkTextFieldRef.current.select();
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [open]);

  // =============== code for single voucher data show

  const [openView, setViewOpen] = useState(false);
  const [vchId, setvchId] = useState("");

  const handleCloseShow = () => setViewOpen(false);

  const handleShowData = async (id) => {
    setViewOpen(true);
    setvchId(id);
  };

  return (
    <>
      <ShowVoucherDetails
        openView={openView}
        vchId={vchId}
        handleCloseShow={handleCloseShow}
        showApproveButton={true}
        showRejectButton={true}
        onApprove={handleVoucherApprove}
        onReject={handleVoucherReject}
      />

      {/* ================= */}
      <Box>
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              width: "400px",
              maxWidth: "50%",
              height: "250px",
            },
          }}
        >
          <DialogTitle variant="h3">
            {bulkReject
              ? "Add Rejection Remark for All Selected"
              : "Add Rejection Remark"}
          </DialogTitle>

          <DialogContent>
            <Box component="form">
              <TextField
                inputRef={remarkTextFieldRef}
                size="small"
                variant="outlined"
                label="Enter Remark"
                fullWidth
                margin="normal"
                value={rejectReason}
                onChange={(event) => setrejectReason(event.target.value)}
                autoFocus
              />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={() => {
                if (bulkReject) {
                  processBulkApproval(
                    SecRows.filter((SecRows) =>
                      selectedIds.includes(SecRows.id)
                    ).map((SecRows) => SecRows.id),
                    0,
                    rejectReason
                  );
                  setBulkReject(false);
                } else {
                  handleApproval(rejectId, "0");
                }
                handleClose();
              }}
              variant="contained"
              sx={{
                mr: 2,
                mb: 2,
                backgroundColor: colors.blueAccent[700],
                color: colors.primary[150], // Custom text color
                "&:hover": {
                  backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                  color: colors.primary[150], // Maintain the same text color on hover
                },
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      {/* =================================================== */}

      {/*Ḥeaders for Table   */}
      <Box mt="70px" ml="0px" mr="20px" id="secondary-approval-table">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Header positioned on the left */}
          <Header
            title="Voucher Approval"
            subtitle="Secondary Voucher Approval"
          />

          {/* ApprovalAll And RejectAll Buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              onClick={() => setOpenPeriod(true)}
              variant="contained"
              sx={{
                height: "35px",
                minHeight: "35px",
                backgroundColor: colors.blueAccent[700], // Custom background color
                color: colors.primary[150], // Custom text color
                "&:hover": {
                  backgroundColor: colors.blueAccent[700], // Maintain the same background on hover
                  color: colors.primary[150], // Maintain the same text color on hover
                },
              }}
            >
              {!fromDate && !toDate ? (
                <>
                  <span>From :- </span>
                  {SecVchs?.length > 0 && SecVchs[0]?.vch_date
                    ? convertDate(SecVchs[0].vch_date)
                    : "—"}
                </>
              ) : (
                <>
                  <span>From :- </span>
                  {fromDate || "—"},<span>To :- </span>
                  {toDate || "—"}
                </>
              )}
            </Button>
            {/* ================= voucher type filter  ================= */}

            <FormControl
              variant="outlined"
              sx={{
                minWidth: 200,
                height: "35px",
                minHeight: "35px",
              }}
            >
              <InputLabel
                id="vch-type-label"
                sx={{
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transform: "translate(14px, 0px) scale(1)", // Fixed positioning
                  "&.Mui-focused, &.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)", // Position when focused/shrunk
                  },
                }}
              >
                Select Vch Type
              </InputLabel>
              <Select
                labelId="vch-type-label"
                value={vchTypeName}
                onChange={handleVchTypeChange}
                label="Select Vch Type"
                sx={{
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  "& .MuiSelect-select": {
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    display: "flex",
                    alignItems: "center",
                  },
                }}
              >
                {VchTypes?.map((item, index) => (
                  <MenuItem key={index} value={item.vch_type}>
                    {item.vch_type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* =============================================== */}

            <Button
              variant="contained"
              color="success"
              sx={{
                height: "30px",
                minHeight: "30px",
              }}
              onClick={() => handleApprovalAll(1)}
            >
              Approve All
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{
                height: "30px",
                minHeight: "30px",
              }}
              onClick={() => handleApprovalAll(0)}
            >
              Reject All
            </Button>
          </Box>
        </Box>

        {/* Vouchers List Table  */}
        <Box
          height="81vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[150],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // ✅ Add horizontal grid lines
            "& .MuiDataGrid-row": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            // ✅ Zoom on hover using a class
            "& .Seczoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
            // ✅ Sticky column styles
            "& .sticky-col-header": {
              position: "sticky",
              right: 0,
              zIndex: 2,
              backgroundColor: colors.blueAccent[700],
            },
            "& .sticky-col": {
              position: "sticky",
              right: 0,
              zIndex: 1,
              backgroundColor: colors.primary[400],
            },
            "& .Seczoom-row:hover .sticky-col": {
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          {isLoading ? (
            <Box 
              display="flex" 
              justifyContent="center" 
              alignItems="center" 
              height="100%"
            >
              <Typography>Loading...</Typography>
            </Box>
          ) : SecRows.length > 0 ? (
            <DataGrid
              rows={SecRows}
              columns={SecColumns}
              pageSize={pageSize}
              onRowClick={(params) => handleShowData(params.row.id)}
              getRowClassName={() => "Seczoom-row"}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[20, 50, 100]}
              pagination
              rowHeight={30}
              headerHeight={30}
              componentsProps={{
                footer: {
                  sx: {
                    height: 30,
                    minHeight: 30,
                  },
                },
              }}
              checkboxSelection
              onSelectionModelChange={(newSelection) =>
                setSelectedIds(newSelection)
              }
              sx={{
                "& .MuiDataGrid-virtualScroller": {
                  overflow: "auto",
                },
                // Hide sort icons completely
                "& .MuiDataGrid-menuIcon, & .MuiDataGrid-sortIcon": {
                  opacity: 0,
                  transition: "opacity 0.2s ease-in-out",
                },
                // Show sort icons only on column header hover
                "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon":
                  {
                    opacity: 1,
                  },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "vchNumber",
                      sort: "asc",
                    },
                  ],
                },
              }}
            />
          ) : (
            <Box 
              display="flex" 
              justifyContent="center" 
              alignItems="center" 
              height="100%"
              flexDirection="column"
              gap={2}
            >
              <Typography variant="h6" color="textSecondary">
                No vouchers available for "{vchTypeName || 'selected type'}"
              </Typography>
              {/* {VchTypes.length > 0 && (
                <Button
                  variant="outlined"
                  onClick={() => {
                    // Switch to the first available voucher type
                    const availableType = VchTypes.find(type => {
                      const filteredData = SecVchs.filter(row => row.vch_type === type.vch_type);
                      return filteredData.length > 0;
                    });
                    if (availableType) {
                      handleVchTypeChange({ target: { value: availableType.vch_type } });
                    } else {
                      // If no data in any type, show all
                      setvchTypeName("");
                      localStorage.setItem(SELECTED_VCH_TYPE_KEY, "");
                      fetchData("");
                    }
                  }}
                >
                  Switch to available voucher type
                </Button>
              )} */}
            </Box>
          )}
        </Box>
      </Box>

      {/*Change Period pop Up Code */}

      <Dialog open={openPeriod} onClose={() => setOpenPeriod(false)}>
        <DialogTitle variant="h2">Change Period</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography sx={{ minWidth: "50px" }}>From :</Typography>
              <TextField
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                size="small"
              />
            </Box>
            <Box display="flex" alignItems="center" gap={2}>
              <Typography sx={{ minWidth: "50px" }}>To :</Typography>
              <TextField
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                size="small"
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenPeriod(false);
              setFromDate("");
              setToDate("");
            }}
          >
            Cancel
          </Button>{" "}
          <Button
            onClick={handleApply}
            variant="contained"
            sx={{
              backgroundColor: "#EFE17C",
              color: "#000000",
              height: "35px",
              minHeight: "35px",
              "&:hover": {
                backgroundColor: "#E6D669",
                color: "#000000",
              },
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SecVchApprov;